import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class ReferralVaultMeta extends BaseEntityModel {
  parentId?: number;
  partnerReferralId?: number | null;
  isPrimary?: boolean;

  constructor(model: Partial<ReferralVaultMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.partnerReferralId = model.partnerReferralId;
    this.isPrimary = model.isPrimary;
  }
}
